import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { FirestoreService } from 'src/app/services/service.index';
declare var google;
import Swal from 'sweetalert2';

@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.css']
})
export class RegionComponent {

 public polygon = [];
 public dW:any;
 public selectedPolygon = null;
 user:any;
 points:any = [];
 nameregion:any;
 polygonEnd = false;
 createdRegions = [];
 idRegion:any;
 deleteRegion = false;
 removeRegion = false;
regionName:any;
color= '#224b8c';

  map:google.maps.Map;


  constructor(private afs: FirestoreService) {

  }

  ngOnInit() {

      this.user = this.afs.usersShow;

      this.loadMap();
  }


  selectPolygon(polygon){
    this.selectedPolygon = polygon;
}


   loadMap(){

    this.createdRegions = []
    const mapEle: HTMLElement = document.getElementById('map');

    //Get current position to init map
    navigator.geolocation.getCurrentPosition( (currentPosition) => {


       const myLatLng = {lat: currentPosition.coords.latitude , lng: currentPosition.coords.longitude};


       const map = new google.maps.Map(mapEle, {
          mapTypeControl: false,
          disableDefaultUI: false,
          streetViewControl: false,
          zoom: 17,
          center: myLatLng, //
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          styles: [], // [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 10 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 32 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }],
          scaleControl: true,
      });


      this.afs.getAllCustomerPro(this.user.companyId).then(res => {

          res.forEach(doc =>{
              //console.log(doc.id);
              let docs = doc.data();
              const myLatLng = {lat: Number(docs.latitude) , lng: Number(docs.longitude)};

              const marker = new google.maps.Marker({
                map: map,
                animation: google.maps.Animation.DROP,
                position: myLatLng
              });
          });


      }).catch(err=>{
          console.log(err);
      });

      const drawingManager = new google.maps.drawing.DrawingManager({
          drawingMode: google.maps.drawing.OverlayType.POLYGON,
          drawingControl: true,
          drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ['polygon']
          },
          polygonOptions: {
              clickable: true,
              draggable: true,
              editable: true,
              zIndex: 1
          },

      });

      drawingManager.setMap(map);

        this.afs.getAllRegion(this.user.companyId).subscribe(regionList => {

          this.clearRegion();

            this.createdRegions=[];

              Object.keys(regionList).forEach((regionListId) => {

                    let region = new google.maps.Polygon({
                      paths: Object.values(regionList[regionListId].polygon),
                      zIndex: 2,
                      strokeColor: "#5c91e6",
                      fillColor: regionList[regionListId].color,
                      fillOpacity: 0.4,
                      strokeWeight: 0.9
                  });

                      let editRegion = {
                          id: regionListId,
                          region: region
                      }

                      //selectedPolygon = newPolygon;
                      google.maps.event.addListener(editRegion.region, 'click', (event) => {

                            /*console.log(regionList[regionListId]);
                            console.log(editRegion.region.Rf);
                            console.log(event);*/

                            editRegion.region.setOptions({strokeWeight: 1.0, fillColor: 'yellow'});


                            this.idRegion = regionList[regionListId].id;
                            this.regionName =  regionList[regionListId].name;
                            console.log(this.idRegion);
                            this.deleteRegion = true;

                     });
                     this.createdRegions.push(region);
                  region.setMap(map);


              });

        });

        google.maps.event.addListenerOnce(map, 'idle', () => {
          //this.mapElement.nativeElement.classList.add('show-map');
        });

          google.maps.event.addListener(drawingManager, 'overlaycomplete',(event) =>{

                this.removeRegion = true;
                this.getPolygon(event);


         });

    });

  }

  getPolygon(event){

    var bounds = event.overlay.getPath().getArray();

    this.points = [];
    bounds.forEach(element => {

          this.points.push({
            lat: element.lat(),
            lng: element.lng()
        });

    });

    if (event.type == 'polygon') {

      /*if (Object.keys(selectedPolygon).length > 0) {
          selectedPolygon.setMap(null);
      }*/

     // let polygon = [];
     // polygon.push(event.overlay.getPath().getArray());

      //console.log("Created polygon: ", event.overlay.getPath().getArray());

      //Add click event to created polygon
      var newPolygon = event.overlay;
      newPolygon.type = event.type;
      this.polygonEnd = true;
      this.selectedPolygon =  newPolygon;

      //selectedPolygon = newPolygon;
      google.maps.event.addListener(newPolygon, 'click', () => {

             this.selectedPolygon =  newPolygon;
        });
  }
  }

  removePolygon(){

  console.log(this.idRegion);

   this.afs.deleteRegion(this.user.companyId, this.idRegion).then((resp:any) =>{


      Swal.fire('Info!', 'Region has been deleted', 'success');

            this.afs.getAllCustomerPro(this.user.companyId).then(locations => {

              locations.forEach(docs => {

                let id = docs.id;
                let locationData = docs.data();

                delete locationData.regions[this.idRegion];
                locationData.region = '';

                  this.afs.updateLocation(this.user.companyId, id, locationData).then(res => {
                        console.log("remove region in location");
                    }).catch(err =>{
                        console.log(err);
                    });
                });

            }).catch(err =>{
                console.log(err);
            });

      }).catch((error) =>{
            console.log(error);
     })
  }

  deletePolygon(){
    if(this.selectedPolygon){
      this.selectedPolygon.setMap(null);
      this.polygon = [];

    }else{
       console.log("should select polygon")
    }

  }

  addRegion(){

    let region = {
      name: this.nameregion,
      color: this.color,
      polygon: this.points
    };


    this.afs.createRegion(this.user.companyId, region).then(resp => {

      Swal.fire('Good job!', 'Region registered Successful!', 'success');


      this.nameregion = '';
      this.polygonEnd = false;
      this.selectedPolygon.setMap(null);
      this.removeRegion = false;


      this.updateLocations(resp.id, this.points, region.name)

    }).catch(err => {

       Swal.fire('Oops...', 'Cant save region!!', 'error');
    });



  }

    clearRegion(){
    this.createdRegions.forEach(region => {
        region.setMap(null);
    });
  }

  refreshMap(){
      //this.clearRegion();
      this.loadMap();
      this.regionName = "";
  }



    updateLocations(regionId, regionPolygon, nameregion) {

      //console.log(regionId);
      let pointArr = [];

      Object.keys(regionPolygon).forEach(function (id, index) {
          var point = [
              regionPolygon[id].lat,
              regionPolygon[id].lng,
          ];
          pointArr.push(point);
      });

      this.afs.getAllCustomerPro(this.user.companyId).then(res => {

        res.forEach(element => {

          let location = [ Number(element.data().latitude), Number(element.data().longitude)];

           //this.afs.getLocationsByRegion
           //console.log(this.afs.inside(location, pointArr));

           if (this.afs.inside(location, pointArr)) {
                //console.log("Inside");
                /*console.log(element.id);
                console.log(regionId);*/
                var data = {};
                var regions = {};
                regions[regionId] = true;
                data['regions'] = regions;
                data['region'] = nameregion;

                this.afs.updateLocation(this.user.companyId, element.id, data).then(res => {
                    console.log("Update Location")
                }).catch(err =>{
                    console.log(err);
                });
           }
        })

      }).catch(err => {
          console.log(err);
      });

    }



}
